"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlmeApiBase = void 0;
const AuthTokenHandlerBase_1 = require("../Authorization/AuthTokenHandlerBase");
const RequestInitHandler_1 = require("../RequestInitHandler");
const errorMessage = 'Invalid Response';
class AlmeApiBase extends AuthTokenHandlerBase_1.AuthTokenHandlerBase {
    constructor(logger, httpHandler, settings) {
        super(logger, httpHandler, settings);
        this.Logger = logger;
        this.HttpHandler = httpHandler;
        this.Settings = settings;
        this.AlmeBaseUri =
            `${this.Settings.AlmeApiProtocol}${this.Settings.AlmeApiHostname}${this.Settings.AlmeApiBasePath}`;
    }
    async SendInputAsync(converseRequest) {
        const converseRequestInfo = `${this.AlmeBaseUri}${this.Settings.AlmeApiConverseEndpoint}`;
        const converseRequestInit = new RequestInitHandler_1.default(this.Logger, this.Settings, 'POST', JSON.stringify(converseRequest));
        this.AddAuthHeader(converseRequestInit);
        const response = await this.HttpHandler.SendAsync(converseRequestInfo, converseRequestInit);
        if (typeof response !== 'object') {
            throw new Error(errorMessage);
        }
        return response;
    }
    async SendAppEventAsync(appEventRequest) {
        const appEventRequestInfo = `${this.AlmeBaseUri}${this.Settings.AlmeApiAppEventEndpoint}`;
        const appEventRequestInit = new RequestInitHandler_1.default(this.Logger, this.Settings, 'POST', JSON.stringify(appEventRequest));
        this.AddAuthHeader(appEventRequestInit);
        const response = await this.HttpHandler.SendAsync(appEventRequestInfo, appEventRequestInit);
        if (typeof response !== 'object') {
            throw new Error(errorMessage);
        }
        return response;
    }
    async SendRequestUnitAsync(requestUnitRequest) {
        const requestUnitRequestInfo = `${this.AlmeBaseUri}${this.Settings.AlmeApiRequestUnitEndpoint}`;
        const requestUnitRequestInit = new RequestInitHandler_1.default(this.Logger, this.Settings, 'POST', JSON.stringify(requestUnitRequest));
        this.AddAuthHeader(requestUnitRequestInit);
        const response = await this.HttpHandler.SendAsync(requestUnitRequestInfo, requestUnitRequestInit);
        if (typeof response !== 'object') {
            throw new Error(errorMessage);
        }
        return response;
    }
    async SendReportingEventAsync(reportingEventRequest) {
        const reportingEventRequestInfo = `${this.AlmeBaseUri}${this.Settings.AlmeApiReportingEventEndpoint}`;
        const reportingEventRequestInit = new RequestInitHandler_1.default(this.Logger, this.Settings, 'POST', JSON.stringify(reportingEventRequest));
        this.AddAuthHeader(reportingEventRequestInit);
        const response = await this.HttpHandler.SendAsync(reportingEventRequestInfo, reportingEventRequestInit);
        if (response === undefined) {
            return true;
        }
        if (typeof response !== 'object') {
            throw new Error(errorMessage);
        }
        return response;
    }
    async GetConfigurationAsync(configRequest) {
        const configRequestInfo = `${this.AlmeBaseUri}${this.Settings.AlmeApiConfigurationEndpoint}`;
        const configRequestInit = new RequestInitHandler_1.default(this.Logger, this.Settings, 'POST', JSON.stringify(configRequest));
        this.AddAuthHeader(configRequestInit);
        const response = await this.HttpHandler.SendAsync(configRequestInfo, configRequestInit);
        if (typeof response !== 'object') {
            throw new Error(errorMessage);
        }
        return response;
    }
    async GetHistoryAsync(historyRequest) {
        const historyRequestInfo = `${this.AlmeBaseUri}${this.Settings.AlmeApiGetHistoryEndpoint}`;
        const historyRequestInit = new RequestInitHandler_1.default(this.Logger, this.Settings, 'POST', JSON.stringify(historyRequest));
        this.AddAuthHeader(historyRequestInit);
        const response = await this.HttpHandler.SendAsync(historyRequestInfo, historyRequestInit);
        if (!Array.isArray(response)) {
            throw new Error(errorMessage);
        }
        return response;
    }
    async EndConversationAsync(endConversationRequest) {
        const endConversationRequestInfo = `${this.AlmeBaseUri}${this.Settings.AlmeApiEndConversationEndpoint}`;
        const endConversationRequestInit = new RequestInitHandler_1.default(this.Logger, this.Settings, 'POST', JSON.stringify(endConversationRequest));
        this.AddAuthHeader(endConversationRequestInit);
        await this.HttpHandler.SendAsync(endConversationRequestInfo, endConversationRequestInit);
        return true;
    }
    async GetPendingMessagesAsync(notificationRequest) {
        const notificationRequestInfo = `${this.AlmeBaseUri}${this.Settings.AlmeApiGetPendingMessagesEndpoint}`;
        const notificationRequestInit = new RequestInitHandler_1.default(this.Logger, this.Settings, 'POST', JSON.stringify(notificationRequest));
        this.AddAuthHeader(notificationRequestInit);
        const response = await this.HttpHandler.SendAsync(notificationRequestInfo, notificationRequestInit);
        if (!Array.isArray(response)) {
            throw new Error(errorMessage);
        }
        return response;
    }
}
exports.AlmeApiBase = AlmeApiBase;
//# sourceMappingURL=AlmeApiBase.js.map